export default {
      id: "circle-uncheck-usage",
      viewBox: "0 0 20 20",
      url: "/dist/svg/" + "sprite.svg#circle-uncheck-usage",
      toString: function () {
        return this.url;
      }
    }